import baseProcessor from 'Commons/redux/postProcessor/BaseProcessor';
import { getTimezoneList } from 'Commons/components/business/timezone/utils/TimezoneHelpers';
import STATUS from 'Commons/config/constants/StoreKeyStatus';

export default (payload, callback, dispatch, localReqOptions) => {
    const timezones = getTimezoneList(payload);
    const result = { response: timezones, status: STATUS.LOADED, error: null };
    return baseProcessor(result, callback, dispatch, localReqOptions);
};
